import { ImisResponseItems } from "../models/imis.models";
import { RestUtility } from "./rest.utility";

/** Static-method namespace for looking up party/user-level information via the iMIS REST API. */
export class PartyUtility {

    /**
     * Determines whether the party with the given ID is a staff user, by resolving their username and checking for a matching CS staff user record.
     * @param id The party/user ID to check.
     * @returns A promise resolving to `true` if a matching staff user record exists, otherwise `false`.
     */
    public static async isUserStaffById(id: string): Promise<boolean> {
        let isStaff = false;

        // get username from id
        let userResponse = await RestUtility.restApiGetData<ImisResponseItems<any>>("/api/user", { userid: id });
        if (userResponse != null && userResponse.Items.length > 0) {
            let user = userResponse.Items[0];
            let username = user.UserName;
            
            let csStaffUserResponse = await RestUtility.restApiGetData<ImisResponseItems<any>>("/api/csstaffuser", { userid: username });
            if (csStaffUserResponse != null && csStaffUserResponse.Items.length > 0) {
                isStaff = true;
            }
        }

        return isStaff;
    }

}